"use strict";

angular.module("core")
.component("partnershipUnpaidInvoicesStatementPrintButton", {
    controllerAs: "partnershipUnpaidInvoiceStatementPrintButtonCtrl",
    templateUrl: require("./partnership-unpaid-invoices-statement-print-button.component.html"),
    bindings: {
        id: "<",
        email: "<?"
    },
    controller: function(
        $scope, FlashBag, gettextCatalog, UserService, EmailInputModalService,
        PartnershipUnpaidInvoicesStatementPrintButtonService
    ) {
        var _this = this;
        $scope.defaultEmail = this.email;

        UserService.isUserFetched().then(function onSuccess(user) {
            if (!_this.email && user) {
                $scope.defaultEmail = user.email;
            }
        });

        this.downloadLetterPDF = function() {
            $scope.isPrintButtonDisabled = true;
            PartnershipUnpaidInvoicesStatementPrintButtonService.downloadPDF(
                this.id
            ).finally(function() {
                $scope.isPrintButtonDisabled = false;
            });
        }

        this.emailLetterPDF = function() {
            var inputPlaceHolder = null;

            EmailInputModalService.inputEmail(
                gettextCatalog.getString("Send file by email"),
                inputPlaceHolder,
                $scope.defaultEmail
            )
            .then(function onSuccess(email) {
                $scope.isEmailButtonDisabled = true;
                PartnershipUnpaidInvoicesStatementPrintButtonService.emailPDF(_this.id, email).$promise
                .then(function onSuccess(data) {
                    FlashBag.emailResult(data.email);
                }).finally(function() {
                    $scope.isEmailButtonDisabled = false;
                });
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/partnership-unpaid-invoices-statement-print-button/partnership-unpaid-invoices-statement-print-button.component.js
// module id = 859
// module chunks = 0